import { render } from "./PostList.vue?vue&type=template&id=1917c214"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"
script.render = render

export default script